import React from 'react';

import {ReactComponent as AccountIcon} from 'src/assets/icons/image-user.svg';
import {BaseScreen, ScreenDivider, ScreenHeader} from '../Screen';
import {UserProfileInterface} from 'src/reducers/users';
import {UserLoader} from 'src/components/UserLoader';
import {ScreenNames} from '../../../lib/analytics/events';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const InputStyle = {
    default: 'w-full p-2 border border-solid border-gray-300 rounded-md',
    disabled: 'w-full p-2 border border-solid border-gray-300 rounded-md bg-gray-100',
};

export function Input(props: InputProps) {
    let style = InputStyle.default;
    if (props.disabled) {
        style = InputStyle.disabled;
    }
    return <input {...props} className={style + (props.className ? ' ' + props.className : '')} />;
}

function Content(props: {user: UserProfileInterface}) {
    const {user} = props;

    function Organization(name: string, uid: string, role: string) {
        return (
            <div className={'flex flex-col md:flex md:flex-row md:items-center'} key={uid}>
                <div className={'hidden w-2/5 md:flex'}>Organization</div>
                <div className={'w-3/5'}>
                    <div className={'flex flex-col gap-6 md:flex md:flex-row'}>
                        <div className={'w-full md:w-1/3'}>
                            <span className='flex pb-3 md:hidden'>Organization Name</span>
                            <Input
                                type={'text'}
                                className='w-[270px] md:w-full'
                                disabled
                                value={name}
                                title={'Organization Name'}
                            />
                        </div>
                        <div className={'w-full md:w-1/3'}>
                            <span className='flex pb-3 md:hidden'>Organization ID</span>
                            <Input
                                type={'text'}
                                className='w-[270px] md:w-full'
                                disabled
                                value={uid}
                                title={'Organization ID'}
                            />
                        </div>
                        <div className={'w-full pb-3 md:w-1/3'}>
                            <span className='flex md:hidden'>Role</span>
                            <Input type={'text'} className='w-[270px] md:w-full' disabled value={role} title={'Role'} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={'flex flex-col gap-8 p-5'}>
            <div className={'flex flex-col md:flex md:flex-row md:items-center'}>
                <div className={'w-2/5'}>Name</div>
                <div className={'mt-3 w-3/5 md:mt-0'}>
                    <div className={'flex'}>
                        <div className={'w-1/2'}>
                            <Input type={'text'} disabled value={user.first_name} className='w-[148px] md:w-full' />
                        </div>
                        <div className={'ml-14 w-1/2'}>
                            <Input type={'text'} disabled value={user.last_name} className='w-[148px] md:w-full' />
                        </div>
                    </div>
                </div>
            </div>
            <div className={'flex flex-col md:flex md:flex-row md:items-center'}>
                <div className={'w-2/5'}>Email</div>
                <div className={'mt-3 w-3/5 md:mt-0'}>
                    <Input type={'text'} className='w-[290px] md:w-full' disabled value={user.email} />
                    <input type={'checkbox'} className={'mt-2'} checked={user.is_verified} disabled />
                    <span className={'ml-2'}>Verified User?</span>
                </div>
            </div>
            {user.org_admins.map((org) => Organization(org.name, org.uid, 'Admin'))}
            {user.org_viewers.map((org) => Organization(org.name, org.uid, 'Member'))}
        </div>
    );
}

export function Profile() {
    const {PROFILE_SCREEN} = ScreenNames;

    return (
        <BaseScreen screenName={PROFILE_SCREEN}>
            <ScreenHeader icon={<AccountIcon className={'stroke-black'} />} title={'Profile'} />
            <ScreenDivider />
            <UserLoader>{(user) => <Content user={user} />}</UserLoader>
        </BaseScreen>
    );
}
